
function getMessage(data, request) {
    return {
	body: data.payload ? data.payload.body : null,
	payload: data.payload,
	type: data.meta.type,
	key: data.meta.uuid,
	date: data.meta.date,
	request: request,
	from: data.envelope.from
    };
}

const MessageExploder = (data) => {
    
    /* if we don't have multiple requests, we don't need to do anything */

    if (!data.meta.requests || (data.meta.requests && !data.meta.requests.length)) {
	return [getMessage(data, null)];
    }
    
    /* copy each request into a new message */
    let messages = [];
    for(var i = 0; i < data.meta.requests.length; ++i) {
	let doIt = true;

	/* check to see if the user has permission to see this request */
	if(!window.pageVariables.manager) {
	    let user_permissions = window.pageVariables.permissions;
	    let request_permissions = data.meta.requests[i].permissions;

	    for(var n = 0; n < request_permissions.length; ++n) {
		if(user_permissions.indexOf(request_permissions[n]) === -1) {
		    doIt = false;
		    console.log("Skipping out, user doesn't have permission: " + request_permissions[n]);
		    break;
		}
	    }
	}
	
	if(doIt) {
	    messages.push(getMessage(data, data.meta.requests[i]));
	}
    }
    return messages;
    
};

export default MessageExploder;
